import axios from 'axios';
import client from './apiClient';
import {
  WaterfallExecutionSearchRequest,
  WaterfallExecutionSearchResponse,
  WaterfallExecutionDetailResponse,
  VoxOrderHistorySearchRequest,
  VoxOrderHistorySearchResponse,
  VoxOrderHistoryDetailResponse,
  TraceContextLogViewModel,
  VendorCapabilityInfo,
  WebhookEventViewModel,
} from '../models/voxTracing';

// ===== Waterfall Execution =====

export const searchWaterfallExecutions = async (
  params: WaterfallExecutionSearchRequest
): Promise<WaterfallExecutionSearchResponse[]> => {
  const { data } = await client.post<WaterfallExecutionSearchResponse[]>(
    '/waterfall-execution-records/search',
    params
  );
  return data;
};

export const getWaterfallExecutionDetail = async (
  guid: string
): Promise<WaterfallExecutionDetailResponse> => {
  try {
    const { data } = await client.get<WaterfallExecutionDetailResponse>(
      `/waterfall-execution-records/detail/${guid}`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      throw new Error('Transaction does not exist');
    }
    throw error;
  }
};

// ===== VoX Order History =====

export const searchVoxOrderHistory = async (
  params: VoxOrderHistorySearchRequest
): Promise<VoxOrderHistorySearchResponse[]> => {
  const { data } = await client.post<VoxOrderHistorySearchResponse[]>(
    '/vox-order-history/search',
    params
  );
  return data;
};

export const getVoxOrderHistoryDetail = async (
  guid: string
): Promise<VoxOrderHistoryDetailResponse> => {
  try {
    const { data } = await client.get<VoxOrderHistoryDetailResponse>(
      `/vox-order-history/detail/${guid}`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      throw new Error('Transaction does not exist');
    }
    throw error;
  }
};

// ===== Trace Logs =====

export const getTraceLogsByVoxOrderGuid = async (
  voxOrderHistoryGuid: string
): Promise<TraceContextLogViewModel[]> => {
  const { data } = await client.get<TraceContextLogViewModel[]>(
    `/vox-order-history/${voxOrderHistoryGuid}/trace-logs`
  );
  return data;
};

export const getFileContent = async (fileRecordId: string): Promise<string> => {
  const { data } = await client.get<string>(`/files/${fileRecordId}/content`, {
    responseType: 'text',
    transformResponse: [(data) => data],
  });
  return data;
};

// ===== Vendor Capabilities =====

export const getVendorCapabilities = async (
  vendor: string
): Promise<VendorCapabilityInfo> => {
  const { data } = await client.get<VendorCapabilityInfo>(
    `/verifications/income-employment-asset/vendor/${vendor}/capabilities`
  );
  return data;
};

// ===== Webhook Events =====

export const resendWebhookEvent = async (
  webhookEventId: string
): Promise<WebhookEventViewModel> => {
  const { data } = await client.post<WebhookEventViewModel>(
    `/events/WebhookEvent/${webhookEventId}/resend`
  );
  return data;
};

// ===== Embed URL =====

export const createEmbedUrl = async (voxOrderGuid: string): Promise<string> => {
  const { data } = await client.post<string>(
    `/verifications/income-employment-asset/order/${voxOrderGuid}/create-url`
  );
  return data;
};
